<p-toast key="soa-message" position="top-right"></p-toast>

<p-confirmDialog [style]="{width: '50vw'}" acceptLabel="Current Page" rejectLabel="All Pages"
                 acceptIcon="pi pi-download"
                 [breakpoints]="{'960px': '75vw', '640px': '100vw'}"
                 [rejectIcon]="isFileDownloading ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
                 [baseZIndex]="10000" acceptButtonStyleClass="p-button-secondary"
                 rejectButtonStyleClass="p-button-secondary"></p-confirmDialog>

<div class="p-mt-3">
    <soa-filters (emitFilterValue)="applyFilterToStatements($event)"></soa-filters>
</div>

<div class="p-mt-3">

    <div class="card">
        <!--        <p-progressBar [style]="{height: '20px', borderRadius: '5px'}" [value]="value"></p-progressBar>-->


        <div class="p-d-block p-d-sm-flex p-ai-center p-jc-between p-pb-3 divider-bottom">

            <div class="p-d-flex p-mx-2 p-ai-center p-jc-between p-jc-lg-start">
                <div>
                    <h5 class="p-m-0 p-text-bold p-text-primary">Statement of Accounts - As of
                        ({{countStats?.updatedDate ? countStats?.updatedDate : 'DD-MMM-YYYY'}}
                        )</h5>
                </div>
                <div class="p-ml-3">
                    <button (click)="refreshSOA()" [icon]="isLoading ? 'pi pi-refresh pi-spin' : 'pi pi-refresh'"
                            class="p-button-secondary"
                            pButton
                            pRipple></button>
                </div>
            </div>

            <div>
                <div class="p-d-flex p-ai-center p-jc-start p-sm-jc-end p-text-secondary p-mt-5 p-mt-sm-0">
                    <div class="divider-right p-d-flex p-ai-center filter-separator p-mr-3 p-pr-3"
                         *ngIf="currencySelection?.length > 1">
                        <div class="p-text-light p-text-secondary">
                            Currency
                        </div>
                        <div class="p-ml-1">
                            <p-dropdown [ngModel]="selectedCurrency" [options]="currencySelection"
                                        (onChange)="applyCurrencyFilter($event)"
                                        class="currency-selection"></p-dropdown>
                        </div>
                    </div>

                    <div *ngIf="countStats?.totalOutStandingValue"
                         [class]="countStats?.overDueAmountValue ? 'filter-separator' : ''"
                         class="p-d-none p-d-xl-flex p-ai-center  p-mr-3 p-pr-3">
                        <div class="p-text-bold">
                            {{countStats?.totalOutStandingValue}}
                        </div>
                        <div class="p-ml-1">
                            {{countStats?.totalOutStandingLabel}}
                        </div>
                    </div>

                    <div *ngIf="countStats?.overDueAmountValue"
                         [class]="countStats?.overDueAmountValue ? 'filter-separator' : ''"
                         class="p-d-none p-d-xl-flex p-ai-center p-mr-3 p-pr-3">
                        <div class="p-text-bold">
                            {{countStats?.overDueAmountValue}}
                        </div>
                        <div class="p-ml-1">
                            {{countStats?.overDueAmountLabel}}
                        </div>
                    </div>

                    <div class=" p-d-flex p-ai-center">
                        <div class="p-mx-3 p-cursor">
                            <img pRipple (click)="downloadFiles('pdf')"
                                 src="assets/branding/shared-icons/export-pdf.svg" class="fp-icon-height p-cursor"
                                 alt="">
                            <!--                                    <i class="pi pi-file-pdf" style="font-size: 1.5rem;"></i>-->
                        </div>
                        <div class="p-cursor">
                            <img pRipple (click)="downloadFiles('excel')"
                                 src="assets/branding/shared-icons/export-excel.svg" class="fp-icon-height p-cursor"
                                 alt="">
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="p-mt-2 p-text-center p-text-secondary p-d-block p-d-xl-none divider-bottom p-pb-2">
            <div class="p-pb-2 p-d-block p-d-md-flex p-ai-center p-jc-center" *ngIf="countStats?.totalOutStandingValue">
                <div class="p-text-bold">
                    {{countStats?.totalOutStandingValue}}
                </div>
                <div class="p-ml-1">
                    {{countStats?.totalOutStandingLabel}}
                </div>
            </div>

            <div class="p-pt-2 p-d-block p-d-md-flex p-ai-center p-jc-center" *ngIf="countStats?.overDueAmountValue">
                <div class="p-text-bold">
                    {{countStats?.overDueAmountValue}}
                </div>
                <div class="p-ml-1">
                    {{countStats?.overDueAmountLabel}}
                </div>
            </div>
        </div>

        <div class="p-text-center">
            <div *ngIf="isLoading" class="p-pt-5" style="min-height: 20vw;margin-top: 40px">
                <p-progressBar [style]="{'height': '6px'}" mode="indeterminate"></p-progressBar>
                <!--                <div>-->
                <!--                    <div class="p-text-secondary pi pi-spin pi-spinner"-->
                <!--                         style="font-size: 2rem"></div>-->
                <!--                </div>-->
                <!--                <div class="p-mt-4 p-font-11">-->
                <!--                    <h5 class="p-text-light">Loading Statements !</h5>-->
                <!--                </div>-->
            </div>

            <div class="p-pt-5" *ngIf="filteredStatements?.content?.length === 0 && !isLoading"
                 style="min-height: 20vw;">
                <div>
                    <button pButton pRipple label="No Statements Found !"
                            class="p-button-text p-text-secondary"></button>
                </div>
            </div>
        </div>

        <!--List & Card View Buttons-->
        <div *ngIf="filteredStatements?.content?.length > 0 && !isLoading"
             class="p-d-none p-d-md-flex p-ai-center p-jc-end p-mt-2 p-pb-2 divider-bottom">
            <div class="p-text-bold p-ml-2">
                <button pButton icon="pi pi-list" class="p-button-secondary"
                        (click)="selectedView = 0"
                        [class]="selectedView === 0 ? '' : 'p-button-text'"></button>
            </div>
            <div class="p-text-bold p-ml-2">
                <button (click)="selectedView = 1" pButton icon="pi pi-id-card" class="p-button-secondary"
                        [class]="selectedView === 1 ? '' : 'p-button-text'"></button>
            </div>
        </div>


        <div *ngIf="filteredStatements?.content?.length > 0 && !isLoading"
             class="p-mt-3 p-mx-1 p-pt-1 ">
            <div>
                <p-tabView styleClass="p-d-none p-d-md-block" [(activeIndex)]="selectedView">
                    <p-tabPanel>
                        <div class="p-d-none p-d-xl-block">
                            <p-table [value]="filteredStatements?.content" [scrollable]="true">

                                <ng-template pTemplate="header">
                                    <tr class="p-text-left width-100">
                                        <th pSortableColumn="invoiceNumber" class="p-py-3" style="width: 11%;">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Invoice Number
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="invoiceNumber"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="billToPartyName" style="width: 9.5%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Bill to
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="billToPartyName"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="transportDocument" style="width: 9.5%;">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Transport Document
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="transportDocument"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="invoiceDate" style="width: 10.5%;">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Invoice Date
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="invoiceDate"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="dueDate" style="width: 10%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Due Date
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="dueDate"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="invoiceCurrency" style="width: 10%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div style="width: 55%">
                                                    Invoice Currency
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="invoiceCurrency"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="formattedInvoiceAmount" style="width: 11%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Amount
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="formattedInvoiceAmount"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="formattedTransactionalAmount" style="width: 10%;">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Transaction Amount
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="formattedTransactionalAmount"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="formattedDueAmount" style="width: 9%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Due
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="formattedDueAmount"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="status" style="width: 9.5%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Status
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="status"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <!--                        <th style="width: 1.5%"></th>-->
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-statement>
                                    <tr class="width-100 divider-bottom">
                                        <td style="width: 11%;">
                                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                                 class="p-d-flex p-ai-center width-100">
                                                <div class="p-text-secondary p-text-bold">
                                                    {{statement?.invoiceNumber ? statement?.invoiceNumber : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 9.5%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                                    {{statement?.billToPartyName ? statement?.billToPartyName : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 9.5%;">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                                    {{statement?.transportDocument ? statement?.transportDocument : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 10.5%;">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                                    {{statement?.invoiceDate ? (statement?.invoiceDate | date: 'dd-MMM-yyyy') : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 10%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                                    {{statement?.dueDate ? (statement?.dueDate | date: 'dd-MMM-yyyy') : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 10%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                                    {{statement?.invoiceCurrency ? statement?.invoiceCurrency : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 11%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                                    {{statement?.formattedInvoiceAmount ? statement?.formattedInvoiceAmount : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 10%;">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                                    {{statement?.formattedTransactionalAmount ? statement?.formattedTransactionalAmount : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 9%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                                    {{statement?.formattedDueAmount ? statement?.formattedDueAmount : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 9.5%">
                                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                                 class="p-d-flex p-ai-center p-jc-between width-100">
                                                <div [class]="statement.status === 'Unpaid' ? 'p-text-danger' : 'p-text-warning'">
                                                    {{statement?.status ? statement?.status : '-'}}
                                                </div>
                                                <div class="p-cursor p-mr-2" (click)="navigateToDocuments(statement)">
                                                    <img src="assets/branding/shared-icons/view.svg" alt=""
                                                         style="height: 1.3rem;"
                                                         (click)="navigateToDocuments(statement)">
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>

                        <div class="p-d-block p-d-xl-none">
                            <soa-tablet [filteredStatements]="filteredStatements"
                                        (emitActions)="handleCardViewActions($event)"></soa-tablet>
                        </div>
                    </p-tabPanel>

                    <p-tabPanel>
                        <div class="p-grid">
                            <div class="p-col-12 p-md-6 p-lg-6 p-xl-4"
                                 *ngFor="let statement of filteredStatements?.content">
                                <soa-card (emitActions)="handleCardViewActions($event)"
                                          [statement]="statement"></soa-card>
                            </div>
                        </div>
                    </p-tabPanel>
                </p-tabView>
            </div>

            <div class="p-d-block p-d-md-none">
                <div class="p-grid">
                    <div class="p-col-12 p-md-6 p-lg-6 p-xl-4"
                         *ngFor="let statement of filteredStatements?.content">
                        <soa-card (emitActions)="handleCardViewActions($event)" [statement]="statement"></soa-card>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div>
        <p-paginator #pagination (onPageChange)="paginateFilteredStatements($event)" [rows]="10"
                     [totalRecords]="filteredStatements?.totalElements"></p-paginator>
    </div>

</div>

<!--                            <p-table [value]="filteredStatements?.content" [scrollable]="true">-->
<!--                                <ng-template pTemplate="header">-->
<!--                                    <tr>-->
<!--                                        <th class="p-py-3" style="width: 140px">-->
<!--                                            <div class="p-d-flex p-ai-center">-->
<!--                                                <div>-->
<!--                                                    Invoice Number-->
<!--                                                </div>-->
<!--                                                <div>-->
<!--                                                    <p-sortIcon></p-sortIcon>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </th>-->

<!--                                        <th style="width: 150px">-->
<!--                                            <div class="p-d-flex p-ai-center">-->
<!--                                                <div>-->
<!--                                                    Bill to-->
<!--                                                </div>-->
<!--                                                <div>-->
<!--                                                    <p-sortIcon></p-sortIcon>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </th>-->

<!--                                        <th style="width: 130px">-->
<!--                                            <div class="p-d-flex p-ai-center">-->
<!--                                                <div>-->
<!--                                                    Transport Document-->
<!--                                                </div>-->
<!--                                                <div>-->
<!--                                                    <p-sortIcon></p-sortIcon>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </th>-->

<!--                                        <th style="width: 140px">-->
<!--                                            <div class="p-d-flex p-ai-center">-->
<!--                                                <div>-->
<!--                                                    Invoice Date-->
<!--                                                </div>-->
<!--                                                <div>-->
<!--                                                    <p-sortIcon></p-sortIcon>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </th>-->

<!--                                        <th style="width: 140px">-->
<!--                                            <div class="p-d-flex p-ai-center">-->
<!--                                                <div>-->
<!--                                                    Due Date-->
<!--                                                </div>-->
<!--                                                <div>-->
<!--                                                    <p-sortIcon></p-sortIcon>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </th>-->

<!--                                        <th style="width: 120px">-->
<!--                                            <div class="p-d-flex p-ai-center">-->
<!--                                                <div>-->
<!--                                                    Invoice Currency-->
<!--                                                </div>-->
<!--                                                <div>-->
<!--                                                    <p-sortIcon></p-sortIcon>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </th>-->

<!--                                        <th style="width: 130px">-->
<!--                                            <div class="p-d-flex p-ai-center">-->
<!--                                                <div>-->
<!--                                                    Amount-->
<!--                                                </div>-->
<!--                                                <div>-->
<!--                                                    <p-sortIcon></p-sortIcon>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </th>-->

<!--                                        <th style="width: 130px">-->
<!--                                            <div class="p-d-flex p-ai-center">-->
<!--                                                <div>-->
<!--                                                    Transaction Amount-->
<!--                                                </div>-->
<!--                                                <div>-->
<!--                                                    <p-sortIcon></p-sortIcon>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </th>-->

<!--                                        <th style="width: 120px">-->
<!--                                            <div class="p-d-flex p-ai-center">-->
<!--                                                <div>-->
<!--                                                    Due-->
<!--                                                </div>-->
<!--                                                <div>-->
<!--                                                    <p-sortIcon></p-sortIcon>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </th>-->
<!--                                        <th style="width: 130px">-->
<!--                                            <div class="p-d-flex p-ai-center">-->
<!--                                                <div>-->
<!--                                                    Status-->
<!--                                                </div>-->
<!--                                                <div>-->
<!--                                                    <p-sortIcon></p-sortIcon>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </th>-->

<!--                                        <th style="width: 30px">-->
<!--                                        </th>-->
<!--                                    </tr>-->
<!--                                </ng-template>-->

<!--                                <ng-template pTemplate="body" let-statement>-->
<!--                                    <tr class="divider-bottom">-->
<!--                                        <td style="width: 140px"-->
<!--                                            [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"-->
<!--                                            class="p-py-4 p-text-bold">{{statement?.invoiceNumber ? statement?.invoiceNumber : '-'}}</td>-->
<!--                                        <td style="width: 150px"-->
<!--                                            [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{statement?.billToPartyName ? statement?.billToPartyName : '-'}}</td>-->
<!--                                        <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"-->
<!--                                            style="width: 130px">{{statement?.transportDocument ? statement?.transportDocument : '-'}}</td>-->
<!--                                        <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"-->
<!--                                            style="width: 140px">{{statement?.invoiceDate ? (statement?.invoiceDate | date: 'dd-MMM-yyyy') : '-'}}</td>-->
<!--                                        <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"-->
<!--                                            style="width: 140px">{{statement?.dueDate ? (statement?.dueDate | date:'dd-MMM-yyyy') : '-'}}</td>-->
<!--                                        <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"-->
<!--                                            style="width: 120px">{{statement?.invoiceCurrency ? statement?.invoiceCurrency : '-'}}</td>-->
<!--                                        <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"-->
<!--                                            style="width: 130px">{{statement?.formattedInvoiceAmount ? statement?.formattedInvoiceAmount : '-'}}</td>-->
<!--                                        <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"-->
<!--                                            style="width: 130px">{{statement?.formattedTransactionalAmount ? statement?.formattedTransactionalAmount : '-'}}</td>-->

<!--                                        <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"-->
<!--                                            style="width: 120px">{{statement?.formattedDueAmount ? statement?.formattedDueAmount : '-'}}</td>-->

<!--                                        <td [class]="statement?.status === 'Unpaid' ? 'p-text-danger' : 'p-text-warning'"-->
<!--                                            style="width: 130px">{{statement?.status ? statement?.status : '-'}}</td>-->

<!--                                        <td style="width: 30px"><img class="p-cursor"-->
<!--                                                                     src="assets/branding/shared-icons/view.svg"-->
<!--                                                                     alt=""-->
<!--                                                                     style="height: 1.3rem;"-->
<!--                                                                     (click)="navigateToDocuments(statement)"></td>-->
<!--                                    </tr>-->
<!--                                </ng-template>-->
<!--                            </p-table>-->
